import React, { useEffect } from "react";
import { useI18next } from "gatsby-plugin-react-i18next";
import { StyledFooter } from "./Footer.styled";
import { isGarenaLocale } from "../../../utils/get-region";
import FooterSG from "./FooterSG/FooterSG";
import FooterTH from "./FooterTH/FooterTH";
import FooterTW from "./FooterTW/FooterTW";
import FooterVN from "./FooterVN/FooterVN";

const Footer: React.FC = () => {
  const { language } = useI18next();

  useEffect(() => {
    const isGarena = isGarenaLocale(language);

    if (isGarena) {
      document.documentElement.classList.add("is-garena");
    } else {
      document.documentElement.classList.remove("is-garena");
    }
  }, [language]);
  return (
    <StyledFooter>
      {(language === "en-sg" || language === "en-ph") && <FooterSG />}
      {language === "th-th" && <FooterTH />}
      {language === "zh-tw" && <FooterTW />}
      {language === "vi-vn" && <FooterVN />}
    </StyledFooter>
  );
};

export default Footer;
